export class MonthItemStatus {
  static get Install () {
    return 1
  }
  static get Stop () {
    return 2
  }
  static get Restart () {
    return 3
  }
  static get Terminate () {
    return 5
  }
  static get Record () {
    return 6
  }

  static MonthItemStatusName (monthItemStatus) {
    let tmpType = parseInt(monthItemStatus)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '安裝'
        break
      case 2:
        name = '暫停'
        break
      case 3:
        name = '重啟'
        break
      case 5:
        name = '終止'
        break
      case 6:
        name = '紀錄'
        break
    }
    return name
  }
}
